import { Component } from '@angular/core';

@Component({
  moduleId: module.id,
  selector: 'loading',
  templateUrl: 'loading.component.html',
  styleUrls: ['loading.component.css']
})

export class LoadingComponent {
}



// WEBPACK FOOTER //
// ./src/app/shared/loading.component.ts